import { render } from "./Documents.vue?vue&type=template&id=a797b8c2&scoped=true&lang=pug"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=a797b8c2&lang=scss&scoped=true"
import "./Documents.vue?vue&type=style&index=1&id=a797b8c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a797b8c2"]])

export default __exports__